import React from "react";

function Home() {
  return (
    <div>
      <h1>Welcome to the Game Hub</h1>
    </div>
  );
}

export default Home;
